(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gwp-wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
  var configNode = document.getElementById('gwp-wishlist-config');
  if (!configNode || window.__gwpWishlist) return;
  window.__gwpWishlist = true;
  var config = JSON.parse(configNode.textContent);
  var text = config.text;
  var pageSelector = '.vtl-proxy-page-wishlist .Vtl-WishlistPage';
  var products = new Map();
  var pending = null;
  var snapshotRequest = null;
  var currency = config.currency;
  var quantities = quantityMap(config.items);
  var root = document.getElementById('content') || document.body;
  var scheduled = false;

  function quantityMap(items) {
    return (items || []).reduce(function (map, item) {
      var id = String(item.variant_id || item.id);
      map[id] = (map[id] || 0) + Number(item.quantity || 0);
      return map;
    }, {});
  }
  function readCart() {
    return fetch(config.cartUrl + '.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      });
  }
  function refreshSnapshot() {
    if (pending || snapshotRequest) return;
    snapshotRequest = readCart().then(function (cart) {
      if (!pending) {
        quantities = quantityMap(cart.items);
        syncCartCount(cart);
      }
      currency = cart.currency || currency;
    }).catch(function () {}).finally(function () { snapshotRequest = null; });
  }
  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function syncCartCount(cart) {
    var count = (cart.items || []).reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
    document.querySelectorAll('.cart-count, .upcart-sticky-cart-quantity-icon-text').forEach(function (node) {
      setText(node, String(count));
    });
  }
  function previewUrl(path) {
    var url = new URL(path, window.location.origin);
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  }
  function link(label, href, primary) {
    var node = document.createElement('a');
    node.className = 'gwp-wishlist-link' + (primary ? ' gwp-wishlist-link--primary' : '');
    node.href = previewUrl(href);
    node.textContent = label;
    return node;
  }
  function status(message, state) {
    var node = root.querySelector('.gwp-wishlist-status');
    if (!node) return;
    node.dataset.state = state || '';
    setText(node, message);
  }
  function openCart(attempt) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      window.location.assign(previewUrl(config.cartUrl));
      return;
    }
    if (typeof window.upcartRefreshCart !== 'function' || typeof window.upcartOpenCart !== 'function') {
      if (attempt < 20) window.setTimeout(function () { openCart(attempt + 1); }, 100);
      else window.location.assign(previewUrl(config.cartUrl));
      return;
    }
    Promise.resolve().then(function () { return window.upcartRefreshCart(); }).then(function () {
      window.upcartOpenCart();
    }).catch(function () { window.location.assign(previewUrl(config.cartUrl)); });
  }
  function checkAddition(watch) {
    if (pending !== watch) return;
    if (Date.now() > watch.deadline) {
      pending = null;
      status(text.check_cart, 'check');
      return;
    }
    readCart().then(function (cart) {
      if (pending !== watch) return;
      quantities = quantityMap(cart.items);
      if (watch.ids.some(function (id) { return (quantities[id] || 0) > (watch.before[id] || 0); })) {
        pending = null;
        syncCartCount(cart);
        status(text.added, 'added');
        openCart(0);
      } else window.setTimeout(function () { checkAddition(watch); }, 350);
    }).catch(function () { window.setTimeout(function () { checkAddition(watch); }, 500); });
  }
  function productUrl(card) {
    var anchor = card.querySelector('.Vtl-WishlistProduct__Link[href]');
    if (!anchor) return null;
    try {
      var url = new URL(anchor.href, window.location.origin);
      if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      return url;
    } catch (error) { return null; }
  }
  function details(card) {
    var action = card.querySelector('.Vtl-WishlistProduct__AddToCart, .Vtl-WishlistProduct__AddedToCart');
    var existing = card.querySelector('.gwp-wishlist-details');
    if (existing) {
      if (action && existing.nextElementSibling !== action) card.insertBefore(existing, action);
      return;
    }
    var url = productUrl(card);
    if (!url) return;
    var box = document.createElement('div');
    box.className = 'gwp-wishlist-details';
    var fallback = document.createElement('a');
    fallback.className = 'gwp-wishlist-price-fallback';
    fallback.href = url.pathname + url.search;
    fallback.textContent = text.price_details;
    box.appendChild(fallback);
    card.insertBefore(box, action);
    var productPath = url.pathname.replace(/\/$/, '') + '.js';
    if (!products.has(productPath)) {
      products.set(productPath, fetch(productPath, {credentials:'same-origin', headers:{Accept:'application/json'}})
        .then(function (response) {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        }).catch(function () { return null; }));
    }
    Promise.all([products.get(productPath), snapshotRequest]).then(function (results) {
      var product = results[0];
      if (!product || !box.isConnected) return;
      var id = url.searchParams.get('variant');
      var variant = (product.variants || []).find(function (item) { return String(item.id) === id; });
      if (!variant || !Number.isFinite(variant.price) || !currency) return;
      var price = document.createElement('span');
      price.className = 'gwp-wishlist-price';
      price.textContent = new Intl.NumberFormat(config.locale, {style:'currency', currency:currency, currencyDisplay:'code'}).format(variant.price / 100);
      box.replaceChildren(price);
      if (variant.sku) {
        var sku = document.createElement('span');
        sku.className = 'gwp-wishlist-sku';
        sku.textContent = text.part_number + ' ' + variant.sku;
        box.appendChild(sku);
      }
    }).catch(function () {});
  }
  function enhance() {
    var page = root.querySelector(pageSelector);
    if (!page || !page.querySelector('.Vtl-WishlistPage__Description')) return;
    setText(page.querySelector('.Vtl-WishlistPage__Title'), text.title);
    setText(page.querySelector('.Vtl-WishlistPage__Description'), text.description);
    setText(document.querySelector('#breadcrumb .page-title'), text.title);
    var toolbar = page.querySelector('.gwp-wishlist-toolbar');
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'gwp-wishlist-toolbar';
      var count = document.createElement('span');
      count.className = 'gwp-wishlist-count';
      toolbar.appendChild(count);
      var actions = document.createElement('div');
      actions.className = 'gwp-wishlist-actions';
      actions.appendChild(link(text.browse, config.browseUrl, false));
      var cartLink = link(text.cart, config.cartUrl, false);
      cartLink.dataset.gwpWishlistCart = '';
      actions.appendChild(cartLink);
      toolbar.appendChild(actions);
      var description = page.querySelector('.Vtl-WishlistPage__Description');
      if (description) description.after(toolbar);
      else page.prepend(toolbar);
      var announcement = document.createElement('p');
      announcement.className = 'gwp-wishlist-status';
      announcement.setAttribute('role', 'status');
      announcement.setAttribute('aria-live', 'polite');
      toolbar.after(announcement);
    }
    // Keep our controls in place when Vitals replaces the list with its empty state.
    var descriptionNode = page.querySelector('.Vtl-WishlistPage__Description');
    if (descriptionNode.nextElementSibling !== toolbar) descriptionNode.after(toolbar);
    var statusNode = page.querySelector('.gwp-wishlist-status');
    if (statusNode && toolbar.nextElementSibling !== statusNode) toolbar.after(statusNode);
    var cards = Array.from(page.querySelectorAll('.Vtl-WishlistProduct'));
    var savedCount = cards.filter(function (card) { return !card.querySelector('.Vtl-WishlistProduct__AddedToCart'); }).length;
    setText(toolbar.querySelector('.gwp-wishlist-count'), text.saved + ' ' + savedCount);
    cards.forEach(function (card) {
      details(card);
      var remove = card.querySelector('.Vtl-WishlistProduct__CloseButton');
      if (remove) {
        remove.setAttribute('role', 'button');
        remove.setAttribute('tabindex', '0');
        var title = card.querySelector('.Vtl-WishlistProduct__Title');
        remove.setAttribute('aria-label', text.remove + (title ? ': ' + title.textContent : ''));
        remove.setAttribute('title', text.remove);
      }
    });
    var empty = page.querySelector('.Vtl-WishlistPage__EmptyList');
    if (empty) {
      setText(empty.querySelector('.Vtl-WishlistPage__EmptyMessage'), text.empty);
      if (!empty.querySelector('.gwp-wishlist-empty-hint')) {
        var hint = document.createElement('p');
        hint.className = 'gwp-wishlist-empty-hint';
        hint.textContent = text.empty_hint;
        empty.appendChild(hint);
        empty.appendChild(link(text.browse, config.browseUrl, true));
      }
    }
  }
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.target.closest(pageSelector + ' .Vtl-WishlistProduct__CloseButton')) status('', '');
    var cartLink = event.target.closest('[data-gwp-wishlist-cart]');
    if (cartLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCart(0);
      return;
    }
    var button = event.target.closest('.Vtl-WishlistProduct__AddToCart');
    if (!button || !button.closest(pageSelector) || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('Vtl-WishlistProduct__AddToCart--disabled')) return;
    var card = button.closest('.Vtl-WishlistProduct');
    var url = card && productUrl(card);
    var id = url && url.searchParams.get('variant');
    if (!id) return;
    // Observe Vitals' request. Never submit a second add or retry a purchase action.
    var watch = {ids:[id], before:Object.assign({}, quantities), deadline:Date.now()+15000};
    pending = watch;
    status(text.adding, 'adding');
    window.setTimeout(function () { checkAddition(watch); }, 250);
  }, true);
  document.addEventListener('keydown', function (event) {
    var remove = event.target.closest && event.target.closest(pageSelector + ' .Vtl-WishlistProduct__CloseButton');
    if (!remove || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    remove.click();
  });
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; enhance(); });
  }).observe(root, {childList:true, subtree:true});
  window.addEventListener('pageshow', refreshSnapshot);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshSnapshot(); });
  function bindCartEvents(attempt) {
    if (typeof window.upcartSubscribeCartLoaded !== 'function' || typeof window.upcartSubscribeCartUpdated !== 'function') {
      if (attempt < 50) window.setTimeout(function () { bindCartEvents(attempt + 1); }, 100);
      return;
    }
    window.upcartSubscribeCartLoaded(refreshSnapshot);
    window.upcartSubscribeCartUpdated(refreshSnapshot);
  }
  bindCartEvents(0);
  refreshSnapshot();
  enhance();
})();
  } catch(e) { console.error(e); }
})();

})();
